import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { TextField } from '@material-ui/core';
import { IntlShape, injectIntl } from 'react-intl';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import frLocale from 'date-fns/locale/fr';
import { get, isEmpty, isNil } from 'lodash';
import {
  DocumentContainer,
  StyledDiv,
} from 'containers/ExpertExpertise/Dialogs/styles';
import * as featureService from 'features/fflip-helpers';
import { FEATURES } from 'features/features';
import DialogMission from 'containers/ExpertExpertise/Dialogs/index';
import { translate } from 'containers/services/translate';
import messages from 'containers/ExpertExpertise/messages';
import { addDaysToDate } from 'containers/common/LegalProceedings/JudgementAdd/Forms/ProcedureInformation/utils';
import UploadDocumentBloc from 'containers/common/LegalProceedings/JudgementAdd/Forms/JudgementAddPrononcings/UploadDocumentBloc';
import {
  DATE_FORMAT,
  DATE_PICKET_FORMAT,
  DOCUMENT_TYPES,
} from 'constants/global';
import {
  DOCUMENT,
  EMPTY_DOCUMENT,
  MISSION_POSTPONE_STATUS,
  MISSION_POSTPONE_TYPE,
} from 'containers/data-structure';
import { IUploadedDocument } from 'containers/LawyerLegalProceedingsPage/typings';
import { dateStringToLocalDate } from 'containers/IdentificationPage/utils';
import moment from 'moment';
import useDeepCompareEffect from 'use-deep-compare-effect';
import currentIntervenantStorage from 'containers/services/security/current-intervenant-storage';
import { getDateIgnoreTimezone } from 'containers/common/LegalProceedings/utils';

export interface PostPoneExpertiseProps {
  intl: IntlShape;
  open: boolean;
  onClose: Function;
  validateDialog: Function;
  uploadDocument: Function;
  uploadedDocument: IUploadedDocument;
  resetUploadedDocument: Function;
  missionId: any;
  recap: any;
  missionDate: any;
}

const PostPoneExpertise: React.FC<PostPoneExpertiseProps> = (
  props,
): JSX.Element => {
  const { onClose, open } = props;
  const [reason, setReason] = useState(null);
  const [postponeDate, setPostponeDate] = useState(null);

  const [postponementsExpertiseDoc, setPostponementsExpertiseDoc] = useState<
    any
  >({
    ...EMPTY_DOCUMENT,
  });
  /* istanbul ignore next */
  useDeepCompareEffect(() => {
    if (!isEmpty(props.recap)) {
      setReason(get(props.recap, 'missionPostPone.reason'));
      setPostponeDate(get(props.recap, 'missionPostPone.postponeDate'));
      setPostponementsExpertiseDoc(
        get(props.recap, 'missionPostPone.document')
          ? get(props.recap, 'missionPostPone.document')
          : {},
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.recap]);

  const handleChangeReason = (event: any) => {
    setReason(event.target.value);
  };

  const handleChangeDate = (date: any) => {
    const theDate = getDateIgnoreTimezone(date);
    const postPonedDate = moment(theDate as Date).format(DATE_FORMAT);
    setPostponeDate(postPonedDate as any);
  };
  /* istanbul ignore next */
  const successCallBack = () => {
    toast.success(translate(messages.successToastPostPone, props));
    props.onClose();
  };
  /* istanbul ignore next */
  const successCallBackUpdate = () => {
    toast.success(
      translate(messages.successToastUpdatedNoticeTitle, props, {
        type: get(props.recap, 'missionPostPone.type'),
      }),
    );
    props.onClose();
  };
  const deleteDoc = () => {
    setPostponementsExpertiseDoc({ ...document, url: '' });
  };
  /* istanbul ignore next */
  const onValidate = () => {
    props.validateDialog(
      {
        ...postponementsExpertiseDoc,
        [DOCUMENT.IS_INDEXED]: false,
        missionId: props.missionId,
        isInboxesActive: featureService.hasFeature(
          FEATURES.ATTRIBUTION_INBOXES_MANAGER,
        ),
        isTrackingActive: featureService.hasFeature(
          FEATURES.TRACKING_ACTIONS_USER,
        ),
        missionPostPone: {
          missionId: props.missionId,
          reason: reason,
          description: null,
          postponeDate:
            isNil(postponeDate) || postponeDate === 'Invalid date'
              ? null
              : postponeDate,
          status: MISSION_POSTPONE_STATUS.PENDING,
          type: MISSION_POSTPONE_TYPE.POSTPONEMENTS_EXPERTISE,
          createdBy: currentIntervenantStorage.get()?.sagis_code,
        },
      },
      successCallBack,
    );
  };

  /* istanbul ignore next */
  const handleValidationUpdate = () => {
    props.validateDialog(
      {
        document: {
          ...postponementsExpertiseDoc,
          isUpdated: true,
          id: get(props.recap, 'missionPostPone.document.id'),
          missionId: props.missionId,
        },
        id: get(props.recap, 'missionPostPone.id'),
        missionId: props.missionId,
        reason: reason,
        postponeDate:
          isNil(postponeDate) || postponeDate === 'Invalid date'
            ? null
            : postponeDate,
        description: null,
        isInboxesActive: featureService.hasFeature(
          FEATURES.ATTRIBUTION_INBOXES_MANAGER,
        ),
        isTrackingActive: featureService.hasFeature(
          FEATURES.TRACKING_ACTIONS_USER,
        ),
        status: MISSION_POSTPONE_STATUS.PENDING,
        type: MISSION_POSTPONE_TYPE.POSTPONEMENTS_EXPERTISE,
      },
      successCallBackUpdate,
    );
  };
  return (
    <>
      <DialogMission
        open={open}
        onClose={onClose}
        validateDialog={
          !isEmpty(props.recap) ? handleValidationUpdate : onValidate
        }
        title={translate({ ...messages.postponementsExpertise }, props)}
        content={
          <StyledDiv>
            <TextField
              onChange={handleChangeReason}
              name={'reason'}
              value={reason}
              label={translate({ ...messages.reason }, props)}
              className="input"
              multiline
              fullWidth
            />
            <MuiPickersUtilsProvider utils={DateFnsUtils} locale={frLocale}>
              <KeyboardDatePicker
                autoOk
                variant="inline"
                name={'postponeDate'}
                className="input"
                invalidDateMessage=""
                format={DATE_PICKET_FORMAT}
                id="postpone-date"
                onChange={handleChangeDate}
                value={dateStringToLocalDate(postponeDate)}
                label={translate(messages.postponeDateField, props)}
                minDate={addDaysToDate(props.missionDate || '', 0)}
                error={postponeDate === 'Invalid date'}
                helperText={
                  postponeDate === 'Invalid date'
                    ? translate(messages.invalidDate, props)
                    : ''
                }
              />
            </MuiPickersUtilsProvider>
            <span style={{ fontSize: '13px', color: 'red' }}>
              {translate({ ...messages.documentStampedTitle }, props)}
            </span>
            <DocumentContainer>
              <UploadDocumentBloc
                index={0}
                document={postponementsExpertiseDoc}
                setDocument={setPostponementsExpertiseDoc}
                resetUploadedDocument={props.resetUploadedDocument}
                uploadDocument={props.uploadDocument}
                uploadedDocument={props.uploadedDocument}
                docType={DOCUMENT_TYPES.POSTPONEMENTS_EXPERTISE}
                deleteDoc={deleteDoc}
              />
            </DocumentContainer>
          </StyledDiv>
        }
        disabled={!reason || !postponementsExpertiseDoc.url}
      />
    </>
  );
};

PostPoneExpertise.defaultProps = {
  open: false,
};

export default injectIntl(PostPoneExpertise);
